import { AlertTriangle } from "lucide-react";

import { Badge } from "@/components/ui/badge";

import {
  ITEMS_WITHOUT_GRADE_DESCRIPTION,
  ITEMS_WITHOUT_GRADE_TITLE,
  MORE_ITEMS_LABEL,
} from "./grade-messages";

const PREVIEW_LIMIT = 10;

interface ItemsWithoutGradeAlertProps {
  itemCodes: string[];
  description?: string;
}

export function ItemsWithoutGradeAlert({
  itemCodes,
  description = ITEMS_WITHOUT_GRADE_DESCRIPTION,
}: ItemsWithoutGradeAlertProps): JSX.Element | null {
  if (itemCodes.length === 0) return null;

  const visible: string[] = itemCodes.slice(0, PREVIEW_LIMIT);
  const hidden: number = itemCodes.length - visible.length;

  return (
    <div
      className="space-y-2 rounded-lg border border-amber-300 bg-amber-50 p-3 dark:border-amber-900 dark:bg-amber-950/20"
      data-testid="items-without-grade"
    >
      <p className="flex items-center gap-2 text-sm font-medium text-amber-900 dark:text-amber-300">
        <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden />
        {ITEMS_WITHOUT_GRADE_TITLE(itemCodes.length)}
      </p>
      <p className="text-xs text-amber-800 dark:text-amber-400">{description}</p>
      <div className="flex flex-wrap gap-1">
        {visible.map((itemCode: string) => (
          <Badge key={itemCode} variant="outline" className="font-mono text-xs">
            {itemCode}
          </Badge>
        ))}
        {hidden > 0 && (
          <Badge variant="secondary" className="text-xs">
            {MORE_ITEMS_LABEL(hidden)}
          </Badge>
        )}
      </div>
    </div>
  );
}
